module.exports = __webpack_public_path__ + "img/wechatBanner.b04ae48b.png";